import TextPlaceholder from '@/components/TextPlaceholder';

export default (mixinOptions = {}) => {
  const assocName = mixinOptions.assocName;
  const resourceName = mixinOptions.resourceName;
  const revisionRouteName = mixinOptions.revisionRouteName;
  const mutationVariables = mixinOptions.mutationVariables;

  return {
    components: {
      TextPlaceholder,
    },
    methods: {
      mutationVariables,
    },
    computed: {
      id() {
        return this.$route.params.id;
      },
      entries() {
        if (!this[resourceName]) return [];
        return this[resourceName][assocName].entries;
      },
      sort() {
        if (!this[resourceName]) return {};
        return this[resourceName][assocName].sort;
      },
      paginate() {
        if (!this[resourceName]) return {};
        return this[resourceName][assocName].pagination;
      },
      queryVariables() {
        return {
          filter: this.filterInfoWithDefault,
          pagination: this.pageInfo,
          sort: this.sortInfo,
          search: this.searchQuery,
          id: this.id,
        };
      },
      breadcrumbs() {
        return [
          {
            text: this.$t('title'),
            route: { name: revisionRouteName, params: { id: this.id } },
          },
        ];
      },
      isSuccessfullyLoaded() {
        return this.isLoaded && this[resourceName];
      },
    },
  };
};



// WEBPACK FOOTER //
// ./mixins/AssocIndexView.js